{
	"timestampTitle": "Timestamp",
	"customerTitle": "Customer",
	"plantTitle": "Plant",
	"productTitle": "Product",
	"invoiceLineItemTitle": "Invoice / Line Item Number",
	"transactionIdTitle": "Transaction ID",
	"epdIdTitle": "EPD ID",
	"statusTitle": "Status",
	"statusLabels": {
		"None": "Unflagged",
		"Flagged": "Flagged",
		"Resolved": "Resolved"
	},
	"quantityTitle": "Quantity",
	"productGwpTitle": "Product GWP",
	"allocatedSavingsTitle": "Allocated carbon reduction",
	"eacEquivalenceTitle": "EAC equivalence",
	"paginationTitle": "View items per page",
	"fetchError": "Failed to load product allocations"
}
